import { checkResponse } from "src/components/js/statics1";
import returnMessageClass from "../system/returnMessageClass";
import tarjousClass from "./tarjousClass";
import tarjousRiviClass from "./tarjousRiviClass";
import { keikkaBetoni_delete_from_db } from "../betoni/KeikkaBetoniFunctions";

export async function tarjous_fetchById(user, tarjousId, token) {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjous/get/" + tarjousId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousFunctions:fetchById");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tarjouksen haku onnistui";
    }
    const tarjous = new tarjousClass();
    await tarjous.initTarjous(cResponse.data, token, user);
    cResponse.returnMessage.data = tarjous;
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:fetchById");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjouksen haku epäonnistui";
    return returnMessage;
  }
}

export async function tarjous_fetchRivi(tarjousRiviId, tarjousId, token) {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjousRivi/get/" + tarjousRiviId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousFunctions:tarjous_fetchRivi");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tarjousrivin haku onnistui";
    }
    const tarjousRivi = new tarjousRiviClass(tarjousId, tarjousRiviId);
    await tarjousRivi.initTarjousRivi(cResponse.data, token);

    cResponse.returnMessage.data = tarjousRivi;
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:tarjous_fetchRivi");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjousrivin haku epäonnistui";
    return returnMessage;
  }
}

export async function tarjous_getCount_byAsiakas(laskuttajaAsiakasId, asiakasId, token) {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        laskuttajaAsiakasId: laskuttajaAsiakasId,
        asiakasId: asiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjous/countByAsiakas",
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousClass:getCount_byAsiakas");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tarjousten laskenta onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:getCount_byAsiakas");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjousten laskenta epäonnistui";
    console.log(error);
    return returnMessage;
  }
}

export async function tarjous_fetchList_byAsiakas(
  laskuttajaAsiakasId,
  asiakasId,
  token,
  includeGlobalTarjous = true
) {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        laskuttajaAsiakasId: laskuttajaAsiakasId,
        asiakasId: asiakasId,
        includeGlobalTarjous: includeGlobalTarjous,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjous/listByAsiakas",
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousClass:fetchTarjousList");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tarjouslistan haku onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:fetchTarjousList");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjouslistan haku epäonnistui";
    console.log(error);
    return returnMessage;
  }
}
export async function tarjousRivi_create_new(tarjousId, token) {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tarjousId: tarjousId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjousRivi/create",
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousFunctions:tarjousRivi_create_new");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data.returnValue;
      cResponse.returnMessage.message = "Tarjousrivin luonti onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousFunctions:tarjousRivi_create_new");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjousrivin luonti epäonnistui";
    console.log(error);
    return returnMessage;
  }
}

export async function tarjous_create_new(
  laskuttajaAsiakasId,
  maksajaAsiakasId,
  token,
  sourceAsiakasId = null
) {
  // use sourceAsiakasId if you want to create tarjous for a sourceAsiakas
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        laskuttajaAsiakasId: laskuttajaAsiakasId,
        asiakasId: maksajaAsiakasId,
        sourceAsiakasId: sourceAsiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjous/create",
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousClass:createNew");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data[0];
      cResponse.returnMessage.message = "Tarjouksen luonti onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:createNew");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjouksen luonti epäonnistui";
    console.log(error);
    return returnMessage;
  }
}
export async function tarjousBetoni_delete(keikkaBetoniId, token, socket, personId) {
  return await keikkaBetoni_delete_from_db(keikkaBetoniId, token, socket, null, personId);
}

export async function tarjousRivi_delete(tarjousRiviId, token) {
  try {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjousRivi/delete/" + tarjousRiviId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousClass:delete");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tarjouksen poisto onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:delete");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjouksen poisto epäonnistui";
    console.log(error);
    return returnMessage;
  }
}
export async function tarjous_delete(tarjousId, token) {
  try {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/hinnat/tarjous/delete/" + tarjousId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "tarjousClass:delete");
    if (cResponse.success) {
      const data = cResponse.data;
      cResponse.returnMessage.data = data;
      cResponse.returnMessage.message = "Tarjouksen poisto onnistui";
    }
    return cResponse.returnMessage;
  } catch (error) {
    const returnMessage = new returnMessageClass("tarjousClass:delete");
    returnMessage.success = false;
    returnMessage.error = error;
    returnMessage.message = "Tarjouksen poisto epäonnistui";
    console.log(error);
    return returnMessage;
  }
}
export async function tarjous_saveToDb_laskuData(tarjous, token) {
  const body = {
    tarjousId: tarjous.tarjousId,
    maksuEhtoPv: tarjous.maksuEhtoPv,
    viitteemmeEval: tarjous.viitteemmeEval,
    viitteemmeResult: tarjous.viitteemmeResult,
    viitteenneEval: tarjous.viitteenneEval,
    viitteenneResult: tarjous.viitteenneResult,
    textBeforeEval: tarjous.textBeforeEval,
    textBeforeResult: tarjous.textBeforeResult,
    textAfterEval: tarjous.textAfterEval,
    textAfterResult: tarjous.textAfterResult,
    sellerName: tarjous.sellerName,
  };
  const url = "/api/hinnat/tarjous/save_laskuData";
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const cResponse = await checkResponse(response, "tarjousClass:saveToDb");
  return cResponse;
}

export async function tarjous_saveToDb_perusData(tarjous, token) {
  const body = {
    tarjousId: tarjous.tarjousId,
    laskuttajaAsiakasId: tarjous.laskuttajaAsiakas.asiakasId,
    asiakasId: tarjous.asiakas?.asiakasId || 0,
    tarjousNimi: tarjous.tarjousNimi,
    selite: tarjous.selite,
    startDate: tarjous.startDate,
    endDate: tarjous.endDate,
    tarjousPvm: tarjous.tarjousPvm,
    evalCriteria: tarjous.evalCriteria,
    evalResultBool: tarjous.evalResultBool,
    evalCustomerText: tarjous.evalCustomerText,
  };
  const url = "/api/hinnat/tarjous/save_perusData";
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const cResponse = await checkResponse(response, "tarjousClass:saveToDb");
  return cResponse;
}
